

// import React, { useState, useRef, useEffect } from 'react';
// import { Search, Send, Users, Database, Clock, BarChart2, CheckCircle, Calendar, Globe, CreditCard, Zap, Camera, Link, Target, Brain, Command, TrendingUp, Wifi, Monitor, Smartphone, Instagram, Facebook, Twitter, Mail, BarChart3, Sparkles, Rocket, Activity, ArrowRight } from 'lucide-react';

// const SwipableFeatureCardsSection = () => {
//   const [activeCardIndex, setActiveCardIndex] = useState(0);
//   const [isScrolling, setIsScrolling] = useState(false);
//   const cardsContainerRef = useRef(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [showSwipeIndicator, setShowSwipeIndicator] = useState(false);
  
//   // Updated features data with new marketing focus
//   const features = [
 
//     { 
//       id: 'COMMAND', 
//       icon: <Command />, 
//       title: 'COMMAND',
//       subtitle: 'AI-Powered Goal Setting',
//       description: 'Tell Kinos your goal and watch AI create, optimize, and execute your marketing strategy automatically.',
//       features: [
//         'Set clear marketing goals',
//         'AI strategy generation',
//         'Automated execution',
//         'Real-time optimization'
//       ]
//     },

//     { 
//       id: 'CREATE', 
//       icon: <Brain />, 
//       title: 'CREATE',
//       subtitle: 'AI Content Studio',
//       description: 'Generate posts, emails, ad copy, and blog ideas instantly. All tailored to your brand and audience.',
//       features: [
//         'AI-generated content',
//         'Brand voice consistency',
//         'Multi-channel content',
//         'Automated personalization'
//       ]
//     },
//     { 
//       id: 'COORDINATE', 
//       icon: <Calendar />, 
//       title: 'COORDINATE',
//       subtitle: 'Smart Scheduling & Automation',
//       description: 'AI optimizes best times and platforms to publish. Schedule everything across all channels automatically.',
//       features: [
//         'Intelligent scheduling',
//         'Cross-channel coordination',
//         'Optimal timing analysis',
//         'Automated publishing'
//       ]
//     },
//     { 
//       id: 'CONNECT', 
//       icon: <Globe />,
//       title: 'CONNECT',
//       subtitle: 'Unified Command Center',
//       description: 'Link all your marketing channels (Social, Email, Ads, Analytics) in one place. No more switching between platforms.',
//       features:
//        [
//         'Connect all marketing channels',
//         'Single dashboard view',
//         'Unified data collection',
//         'Cross-platform insights'
//       ]
//     },
//     { 
//       id: 'CALIBRATE', 
//       icon: <TrendingUp />, 
//       title: 'CALIBRATE',
//       subtitle: 'Performance Optimization',
//       description: 'AI analyzes performance in real-time, suggests improvements, and automates A/B tests for maximum results.',
//       features: [
//         'Real-time analytics',
//         'AI optimization suggestions',
//         'Automated A/B testing',
//         'Performance insights'
//       ]
//     }
//   ];
  
//   // Function to determine which card is most visible
//   const updateActiveCard = () => {
//     if (cardsContainerRef.current) {
//       const container = cardsContainerRef.current;
//       const scrollPosition = container.scrollLeft;
//       const containerWidth = container.offsetWidth;
      
//       // Check if we're at the right edge of the scroll container
//       const maxScroll = container.scrollWidth - containerWidth;
//       const isAtEnd = scrollPosition >= maxScroll - 20;
      
//       if (isAtEnd && !isScrolling) {
//         // Scroll back to the first card when reaching the end
//         setIsScrolling(true);
//         container.scrollTo({
//           left: 0,
//           behavior: 'smooth'
//         });
//         setActiveCardIndex(0);
//         setTimeout(() => setIsScrolling(false), 500);
//         return;
//       }
      
//       // Find which card is most visible
//       const cards = Array.from(container.querySelectorAll('.feature-card'));
//       let closestCard = 0;
//       let closestDistance = Infinity;
      
//       cards.forEach((card, index) => {
//         const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
//         const containerCenter = scrollPosition + (containerWidth / 2);
//         const distance = Math.abs(cardCenter - containerCenter);
        
//         if (distance < closestDistance) {
//           closestDistance = distance;
//           closestCard = index;
//         }
//       });
      
//       if (closestCard !== activeCardIndex) {
//         setActiveCardIndex(closestCard % features.length);
//       }
//     }
//   };
  
//   // Create "infinite" scroll effect by duplicating cards
//   const extendedFeatures = [...features, ...features.slice(0, 2)];
  
//   // Handle scroll events
//   useEffect(() => {
//     const container = cardsContainerRef.current;
//     let scrollTimer;
    
//     const handleScroll = () => {
//       clearTimeout(scrollTimer);
//       scrollTimer = setTimeout(() => {
//         updateActiveCard();
//       }, 100);
//     };
    
//     if (container) {
//       container.addEventListener('scroll', handleScroll);
      
//       return () => {
//         container.removeEventListener('scroll', handleScroll);
//         clearTimeout(scrollTimer);
//       };
//     }
//   }, [activeCardIndex]);
  
//   // Show swipe indicator on mobile always
//   useEffect(() => {
//     const isMobile = window.innerWidth < 768;
//     if (isMobile) {
//       setShowSwipeIndicator(true);
//     }
//   }, []);
  
//   // Track horizontal movement to distinguish between scrolling and swiping
//   const [touchStartY, setTouchStartY] = useState(0);
//   const [isHorizontalSwipe, setIsHorizontalSwipe] = useState(false);
  
//   // Scroll to a specific card test
//   const scrollToCard = (index) => {
//     if (cardsContainerRef.current) {
//       const cardElements = cardsContainerRef.current.querySelectorAll('.feature-card');
//       if (cardElements && cardElements[index]) {
//         cardsContainerRef.current.scrollTo({
//           left: cardElements[index].offsetLeft - 16, // Account for container padding
//           behavior: 'smooth'
//         });
//       }
//     }
//   };
  
//   return (
//     <section id="features" className="py-4 md:py-16 bg-gradient-to-br from-gray-50 to-[#c4ffa0]/10">
//       {/* Container with no horizontal padding on mobile */}
//       <div className="max-w-[1600px] mx-auto px-0 md:px-6">
//         <div className="text-center mb-6 md:mb-10 px-4">
//           <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-2">How Kinos Works (The Magic)</h2>
//           <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto">
//             Simple 5-step process that transforms marketing chaos into organized, automated success.
//           </p>
//         </div>
        
      

//         {/* Swipable cards and pagination dots */}
//         <div className="w-full overflow-hidden px-4 md:px-6 relative">
//           {/* Mobile swipe right indicator */}
//           {showSwipeIndicator && (
//             <div className="md:hidden pointer-events-none select-none absolute right-4 top-1/2 z-20 flex items-center animate-fade-in-up" style={{transform: 'translateY(-50%)'}}>
//               <span className="text-xs font-semibold text-[#2d4a1e] bg-white/90 rounded-full px-2 py-1 shadow-md mr-1 animate-pulse">Swipe</span>
//               <svg className="w-5 h-5 text-[#2d4a1e] animate-bounce-x" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"/></svg>
//             </div>
//           )}
//           {/* Left/right indicator arrows for desktop */}
//           <div className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10">
//             <button 
//               className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-200"
//               onClick={() => {
//                 const prevIndex = activeCardIndex === 0 ? features.length - 1 : activeCardIndex - 1;
//                 scrollToCard(prevIndex);
//               }}
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//                 <path d="M15 18l-6-6 6-6"/>
//               </svg>
//             </button>
//           </div>
          
//           <div className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10">
//             <button 
//               className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-200"
//               onClick={() => {
//                 const nextIndex = (activeCardIndex + 1) % features.length;
//                 scrollToCard(nextIndex);
//               }}
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-green-600">
//                 <path d="M9 18l6-6-6-6"/>
//               </svg>
//             </button>
//           </div>
          
//           {/* Swipable cards */}
//           <div 
//             ref={cardsContainerRef}
//             className="flex overflow-x-auto snap-x snap-mandatory pb-6 hide-scrollbar"
//             style={{ WebkitOverflowScrolling: 'touch' }}
//           >
//             {extendedFeatures.map((feature, index) => (
//               <div 
//                 key={`${feature.id}-${index}`}
//                 className="feature-card snap-center w-[calc(100%-32px)] sm:w-[calc(80%-32px)] md:w-[calc(40%-32px)] lg:w-[calc(25%-32px)] mr-4 flex-shrink-0 transition-all duration-300"
//               >
//                 <div className="bg-white border border-gray-200/50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 h-full flex flex-col min-h-[420px] md:min-h-[460px] overflow-hidden group hover:scale-[1.02]">
//                   {/* Card header */}
//                   <div className={`p-5 border-b border-gray-100 ${
//                     index % 2 === 0 
//                       ? 'bg-gradient-to-br from-[#c4ffa0]/10 via-[#c4ffa0]/5 to-transparent' 
//                       : 'bg-gradient-to-br from-blue-500/8 via-[#c4ffa0]/5 to-transparent'
//                   }`}>
//                     <div className="flex items-center mb-2">
//                       <div className="bg-[#c4ffa0]/20 rounded-xl p-2 mr-3 shadow-md group-hover:shadow-lg transition-shadow">
//                         {React.cloneElement(feature.icon, { className: 'w-5 h-5 text-[#2d4a1e]' })}
//                       </div>
//                       <h3 className="text-lg md:text-xl font-bold text-gray-800">{feature.title}</h3>
//                     </div>
//                     <p className="text-[#2d4a1e] font-semibold text-sm md:text-base">{feature.subtitle}</p>
//                   </div>
                  
//                   {/* Enhanced Visual elements */}
//                   <div className="p-4 bg-gradient-to-br from-gray-50/50 to-green-50/30 h-36 md:h-40 flex items-center justify-center relative overflow-hidden">
//                     {/* CONNECT Card - Multi-platform connection hub */}
//                     {index % features.length === 3 && (
//                       <div className="relative w-full h-full">
//                         {/* Animated connection lines background */}
//                         <div className="absolute inset-0 opacity-20">
//                           <div className="absolute top-1/2 left-1/2 w-32 h-32 -translate-x-1/2 -translate-y-1/2">
//                             <div className="absolute top-0 left-1/2 w-0.5 h-8 bg-gradient-to-b from-[#c4ffa0] to-blue-400 animate-pulse"></div>
//                             <div className="absolute bottom-0 left-1/2 w-0.5 h-8 bg-gradient-to-t from-purple-400 to-pink-400 animate-pulse"></div>
//                             <div className="absolute top-1/2 left-0 w-8 h-0.5 bg-gradient-to-r from-orange-400 to-red-400 animate-pulse"></div>
//                             <div className="absolute top-1/2 right-0 w-8 h-0.5 bg-gradient-to-l from-cyan-400 to-teal-400 animate-pulse"></div>
//                           </div>
//                         </div>
                        
//                         {/* Central hub */}
//                         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
//                           <div className="bg-white rounded-2xl p-4 shadow-xl border-2 border-[#c4ffa0]/30 w-20 h-20 flex items-center justify-center">
//                             <Globe className="w-8 h-8 text-[#2d4a1e]" />
//                           </div>
//                         </div>
                        
//                         {/* Platform icons floating around */}
//                         <div className="absolute top-2 left-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg p-2 shadow-lg animate-bounce">
//                           <Facebook className="w-4 h-4" />
//                         </div>
//                         <div className="absolute top-2 right-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg p-2 shadow-lg animate-bounce" style={{ animationDelay: '0.2s' }}>
//                           <Instagram className="w-4 h-4" />
//                         </div>
//                         <div className="absolute bottom-2 left-4 bg-gradient-to-r from-blue-400 to-cyan-500 text-white rounded-lg p-2 shadow-lg animate-bounce" style={{ animationDelay: '0.4s' }}>
//                           <Twitter className="w-4 h-4" />
//                         </div>
//                         <div className="absolute bottom-2 right-4 bg-gradient-to-r from-red-500 to-orange-500 text-white rounded-lg p-2 shadow-lg animate-bounce" style={{ animationDelay: '0.6s' }}>
//                           <Mail className="w-4 h-4" />
//                         </div>
                        
//                         {/* Status indicator */}
//                         <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 bg-[#c4ffa0] text-[#2d4a1e] text-xs px-3 py-1 rounded-full font-bold shadow-lg">
//                           ALL CONNECTED ✓
//                         </div>
//                       </div>
//                     )}
                    
//                     {/* COMMAND Card - AI Goal Setting Interface */}
//                     {index % features.length === 0 && (
//                       <div className="relative w-full h-full">
//                         {/* AI brain animation background */}
//                         <div className="absolute inset-0 bg-gradient-to-br from-purple-100/50 to-blue-100/50 rounded-xl"></div>
                        
//                         {/* Main AI interface */}
//                         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[200px]">
//                           <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 shadow-xl border border-gray-200">
//                             <div className="flex items-center justify-between mb-3">
//                               <div className="flex items-center space-x-2">
//                                 <div className="w-6 h-6 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center">
//                                   <Sparkles className="w-3 h-3 text-white" />
//                                 </div>
//                                 <span className="text-xs font-bold text-gray-800">AI ASSISTANT</span>
//                               </div>
//                               <div className="flex space-x-1">
//                                 <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></div>
//                                 <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
//                                 <div className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
//                               </div>
//                             </div>
                            
//                             <div className="space-y-2 text-xs">
//                               <div className="bg-gray-100 rounded-lg p-2">
//                                 <div className="text-gray-600 mb-1">Your Goal:</div>
//                                 <div className="text-gray-800 font-medium">"Increase sales by 30%"</div>
//                               </div>
//                               <div className="bg-gradient-to-r from-[#c4ffa0]/20 to-blue-100/50 rounded-lg p-2">
//                                 <div className="flex items-center space-x-2">
//                                   <Rocket className="w-3 h-3 text-[#2d4a1e]" />
//                                   <span className="text-[#2d4a1e] font-medium">Strategy Generated!</span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
                        
//                         {/* Floating action indicators */}
//                         <div className="absolute top-2 right-2 bg-gradient-to-r from-[#c4ffa0] to-green-400 text-[#2d4a1e] rounded-full px-2 py-1 text-xs font-bold shadow-lg animate-pulse">
//                           AI WORKING
//                         </div>
//                         <div className="absolute bottom-2 left-2 bg-gradient-to-r from-blue-400 to-purple-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg">
//                           AUTO-PILOT ON
//                         </div>
//                       </div>
//                     )}
                    
//                     {/* CREATE Card - AI Content Studio */}
//                     {index % features.length === 1&& (
//                       <div className="relative w-full h-full">
//                         {/* Creative background */}
//                         <div className="absolute inset-0 bg-gradient-to-br from-pink-50/50 to-orange-50/50 rounded-xl"></div>
                        
//                         {/* Content creation interface */}
//                         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[180px]">
//                           <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-3 shadow-xl border border-gray-200">
//                             <div className="flex items-center justify-between mb-3">
//                               <div className="flex items-center space-x-2">
//                                 <Brain className="w-4 h-4 text-[#2d4a1e]" />
//                                 <span className="text-xs font-bold text-gray-800">AI STUDIO</span>
//                               </div>
//                               <div className="bg-gradient-to-r from-orange-400 to-pink-500 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs">
//                                 ✨
//                               </div>
//                             </div>
                            
//                             {/* Content types */}
//                             <div className="grid grid-cols-2 gap-2 mb-3">
//                               <div className="bg-gradient-to-r from-blue-100 to-cyan-100 rounded-lg p-2 text-center">
//                                 <Camera className="w-4 h-4 text-blue-600 mx-auto mb-1" />
//                                 <div className="text-xs font-medium text-blue-800">Posts</div>
//                               </div>
//                               <div className="bg-gradient-to-r from-purple-100 to-pink-100 rounded-lg p-2 text-center">
//                                 <Mail className="w-4 h-4 text-purple-600 mx-auto mb-1" />
//                                 <div className="text-xs font-medium text-purple-800">Emails</div>
//                               </div>
//                             </div>
                            
//                             {/* Generation status */}
//                             <div className="bg-gradient-to-r from-[#c4ffa0]/20 to-green-100/50 rounded-lg p-2">
//                               <div className="flex items-center space-x-2">
//                                 <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
//                                 <span className="text-xs font-medium text-green-800">Generating content...</span>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
                        
//                         {/* Floating elements */}
//                         <div className="absolute top-2 left-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg animate-bounce">
//                           WRITING
//                         </div>
//                         <div className="absolute bottom-2 right-2 bg-gradient-to-r from-green-400 to-teal-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg animate-bounce" style={{ animationDelay: '0.3s' }}>
//                           BRANDED
//                         </div>
//                       </div>
//                     )}
                    
//                     {/* COORDINATE Card - Smart Scheduling Dashboard */}
//                     {index % features.length === 2 && (
//                       <div className="relative w-full h-full">
//                         {/* Scheduling background */}
//                         <div className="absolute inset-0 bg-gradient-to-br from-indigo-50/50 to-purple-50/50 rounded-xl"></div>
                        
//                         {/* Calendar interface */}
//                         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[200px]">
//                           <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-3 shadow-xl border border-gray-200">
//                             <div className="flex items-center justify-between mb-3">
//                               <div className="flex items-center space-x-2">
//                                 <Calendar className="w-4 h-4 text-[#2d4a1e]" />
//                                 <span className="text-xs font-bold text-gray-800">SCHEDULER</span>
//                               </div>
//                               <div className="bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs">
//                                 ⏰
//                               </div>
//                             </div>
                            
//                             {/* Mini calendar grid */}
//                             <div className="grid grid-cols-7 gap-1 mb-3">
//                               {Array.from({ length: 14 }, (_, i) => (
//                                 <div key={i} className={`w-3 h-3 rounded-sm ${
//                                   i === 5 || i === 8 || i === 12 
//                                     ? 'bg-gradient-to-r from-[#c4ffa0] to-green-400' 
//                                     : i === 3 || i === 10 
//                                     ? 'bg-gradient-to-r from-blue-400 to-purple-500' 
//                                     : 'bg-gray-100'
//                                 }`}></div>
//                               ))}
//                             </div>
                            
//                             {/* Optimal times */}
//                             <div className="space-y-1">
//                               <div className="flex items-center justify-between text-xs">
//                                 <span className="text-gray-600">Best Time:</span>
//                                 <span className="font-bold text-green-600">2:30 PM</span>
//                               </div>
//                               <div className="flex items-center justify-between text-xs">
//                                 <span className="text-gray-600">Next Post:</span>
//                                 <span className="font-bold text-blue-600">5 min</span>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
                        
//                         {/* Platform indicators */}
//                         <div className="absolute top-2 left-2 flex space-x-1">
//                           <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center">
//                             <div className="w-2 h-2 bg-white rounded-full"></div>
//                           </div>
//                           <div className="w-4 h-4 bg-pink-500 rounded-full flex items-center justify-center">
//                             <div className="w-2 h-2 bg-white rounded-full"></div>
//                           </div>
//                           <div className="w-4 h-4 bg-purple-500 rounded-full flex items-center justify-center">
//                             <div className="w-2 h-2 bg-white rounded-full"></div>
//                           </div>
//                         </div>
                        
//                         <div className="absolute bottom-2 right-2 bg-gradient-to-r from-green-400 to-teal-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg animate-pulse">
//                           AUTO-SCHEDULED
//                         </div>
//                       </div>
//                     )}
                    
//                     {/* CALIBRATE Card - Performance Dashboard */}
//                     {index % features.length === 4 && (
//                       <div className="relative w-full h-full">
//                         {/* Analytics background */}
//                         <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/50 to-teal-50/50 rounded-xl"></div>
                        
//                         {/* Performance dashboard */}
//                         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[200px]">
//                           <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-3 shadow-xl border border-gray-200">
//                             <div className="flex items-center justify-between mb-3">
//                               <div className="flex items-center space-x-2">
//                                 <TrendingUp className="w-4 h-4 text-[#2d4a1e]" />
//                                 <span className="text-xs font-bold text-gray-800">ANALYTICS</span>
//                               </div>
//                               <div className="bg-gradient-to-r from-green-500 to-teal-600 text-white rounded-full w-4 h-4 flex items-center justify-center text-xs">
//                                 📊
//                               </div>
//                             </div>
                            
//                             {/* Mini chart */}
//                             <div className="bg-gray-50 rounded-lg p-2 mb-3">
//                               <div className="flex items-end justify-between h-8 space-x-1">
//                                 <div className="w-2 bg-gradient-to-t from-blue-400 to-blue-500 h-4 rounded-t"></div>
//                                 <div className="w-2 bg-gradient-to-t from-green-400 to-green-500 h-6 rounded-t"></div>
//                                 <div className="w-2 bg-gradient-to-t from-purple-400 to-purple-500 h-5 rounded-t"></div>
//                                 <div className="w-2 bg-gradient-to-t from-[#c4ffa0] to-green-400 h-8 rounded-t"></div>
//                                 <div className="w-2 bg-gradient-to-t from-orange-400 to-yellow-500 h-7 rounded-t"></div>
//                               </div>
//                             </div>
                            
//                             {/* Performance metrics */}
//                             <div className="space-y-1">
//                               <div className="flex items-center justify-between text-xs">
//                                 <span className="text-gray-600">ROI:</span>
//                                 <span className="font-bold text-green-600">+127%</span>
//                               </div>
//                               <div className="flex items-center justify-between text-xs">
//                                 <span className="text-gray-600">Engagement:</span>
//                                 <span className="font-bold text-blue-600">+89%</span>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
                        
//                         {/* Status indicators */}
//                         <div className="absolute top-2 right-2 bg-gradient-to-r from-green-400 to-teal-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg animate-pulse">
//                           OPTIMIZING
//                         </div>
//                         <div className="absolute bottom-2 left-2 bg-gradient-to-r from-purple-400 to-pink-500 text-white rounded-full px-2 py-1 text-xs font-bold shadow-lg">
//                           A/B TESTING
//                         </div>
//                       </div>
//                     )}
//                   </div>
                  
//                   {/* Card content */}
//                   <div className="p-5 flex-grow flex flex-col justify-between">
//                     <div>
//                       <p className="text-gray-700 mb-3 text-sm font-medium leading-relaxed">
//                         {feature.description}
//                       </p>
                      
//                       <div className="mt-3 space-y-2">
//                         {feature.features.slice(0, 4).map((featureItem, i) => (
//                           <div key={i} className="flex items-start">
//                             <div className="text-green-500 mr-2 mt-0.5 text-sm font-bold">✓</div>
//                             <p className="text-gray-600 text-xs md:text-sm leading-relaxed">{featureItem}</p>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
          
//           {/* Enhanced Pagination dots */}
//           <div className="flex justify-center mt-4 gap-3 pb-2">
//             {features.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => {
//                   scrollToCard(index);
//                   setActiveCardIndex(index);
//                 }}
//                 className={`h-3 w-3 rounded-full transition-all duration-300 ${
//                   index === activeCardIndex 
//                     ? 'bg-[#2d4a1e] shadow-lg scale-110' 
//                     : 'bg-[#2d4a1e]/40 hover:bg-[#2d4a1e]/60'
//                 }`}
//                 aria-label={`View ${features[index].title} feature`}
//                 style={{ minHeight: '12px', minWidth: '12px' }}
//               ></button>
//             ))}
//           </div>
//         </div>

//   {/* Demo image at the top, larger and centered */}
//   <div className="w-full flex justify-center mb-4 mt-8 px-2 md:px-0">
//           <div className="w-full max-w-6xl bg-white rounded-2xl shadow-2xl border border-gray-100 p-2 md:p-8 flex items-center justify-center">
//             <img 
//               src="/demo_view_1.png" 
//               alt="Kinos Dashboard Screenshot" 
//               className="rounded-xl shadow-lg w-full h-auto object-contain border border-gray-100"
//               style={{ background: '#f8fafc' }}
//             />
//           </div>
//         </div>

//       </div>
      
//       <style jsx>{`
//         .hide-scrollbar {
//           -ms-overflow-style: none;
//           scrollbar-width: none;
//         }
//         .hide-scrollbar::-webkit-scrollbar {
//           display: none;
//         }
        
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes pulse {
//           0%, 100% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0.7;
//           }
//         }
        
//         @keyframes bounce {
//           0%, 100% {
//             transform: translateY(-25%);
//             animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
//           }
//           50% {
//             transform: translateY(0);
//             animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
//           }
//         }
        
//         .animate-pulse {
//           animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//         }
        
//         .animate-bounce {
//           animation: bounce 1s infinite;
//         }
        
//         /* Custom responsive animations */
//         @media (max-width: 768px) {
//           .animate-bounce {
//             animation: bounce 1.5s infinite;
//           }
//         }
//         .animate-fade-in-up {
//           animation: fadeInUp 0.7s cubic-bezier(0.4,0,0.2,1);
//         }
//         @keyframes bounceX {
//           0%, 100% {
//             transform: translateX(0);
//             animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
//           }
//           50% {
//             transform: translateX(10px);
//             animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
//           }
//         }
//         .animate-bounce-x {
//           animation: bounceX 1.2s infinite;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default SwipableFeatureCardsSection;
import React, { useState, useRef, useEffect } from 'react';
import { Command, Brain, Calendar, Globe, TrendingUp, ArrowRight } from 'lucide-react';

const MinimalFeatureCards = () => {
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const cardsContainerRef = useRef(null);
  
  const features = [
    { 
      id: 'COMMAND', 
      icon: <Command />, 
      title: 'COMMAND',
      subtitle: 'Set Your Goal',
      description: 'Tell us your marketing goal. AI creates the strategy.',
      visual: 'goal'
    },
    { 
      id: 'CREATE', 
      icon: <Brain />, 
      title: 'CREATE',
      subtitle: 'AI Content Studio',
      description: 'Generate posts, emails, and ads instantly.',
      visual: 'content'
    },
    { 
      id: 'COORDINATE', 
      icon: <Calendar />, 
      title: 'COORDINATE',
      subtitle: 'Smart Scheduling',
      description: 'AI finds the best times and publishes automatically.',
      visual: 'schedule'
    },
    { 
      id: 'CONNECT', 
      icon: <Globe />,
      title: 'CONNECT',
      subtitle: 'All Platforms',
      description: 'Link all your marketing channels in one dashboard.',
      visual: 'connect'
    },
    { 
      id: 'CALIBRATE', 
      icon: <TrendingUp />, 
      title: 'CALIBRATE',
      subtitle: 'Optimize Results',
      description: 'AI analyzes performance and improves automatically.',
      visual: 'optimize'
    }
  ];
  
  const updateActiveCard = () => {
    if (cardsContainerRef.current) {
      const container = cardsContainerRef.current;
      const scrollPosition = container.scrollLeft;
      const containerWidth = container.offsetWidth;
      
      const cards = Array.from(container.querySelectorAll('.feature-card'));
      let closestCard = 0;
      let closestDistance = Infinity;
      
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + (card.offsetWidth / 2);
        const containerCenter = scrollPosition + (containerWidth / 2);
        const distance = Math.abs(cardCenter - containerCenter);
        
        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = index;
        }
      });
      
      if (closestCard !== activeCardIndex && closestCard < features.length) {
        setActiveCardIndex(closestCard);
      }
    }
  };
  
  useEffect(() => {
    const container = cardsContainerRef.current;
    let scrollTimer;
    
    const handleScroll = () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        updateActiveCard();
      }, 100);
    };
    
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => {
        container.removeEventListener('scroll', handleScroll);
        clearTimeout(scrollTimer);
      };
    }
  }, [activeCardIndex]);
  
  const scrollToCard = (index) => {
    if (cardsContainerRef.current) {
      const cardElements = cardsContainerRef.current.querySelectorAll('.feature-card');
      if (cardElements && cardElements[index]) {
        cardsContainerRef.current.scrollTo({
          left: cardElements[index].offsetLeft - 16,
          behavior: 'smooth'
        });
      }
    }
  };

  const renderVisual = (visual) => {
    const visualStyles = "w-full h-32 flex items-center justify-center";
    
    switch(visual) {
      case 'goal':
        return (
          <div className={visualStyles}>
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-100 to-blue-100 rounded-2xl flex items-center justify-center">
                <Command className="w-10 h-10 text-purple-600" />
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">✓</span>
              </div>
            </div>
          </div>
        );
      
      case 'content':
        return (
          <div className={visualStyles}>
            <div className="space-y-2 w-full max-w-[160px]">
              <div className="h-4 bg-gradient-to-r from-pink-200 to-purple-200 rounded-full"></div>
              <div className="h-4 bg-gradient-to-r from-blue-200 to-cyan-200 rounded-full w-3/4"></div>
              <div className="h-4 bg-gradient-to-r from-green-200 to-teal-200 rounded-full w-1/2"></div>
              <div className="flex items-center justify-center mt-4">
                <Brain className="w-8 h-8 text-purple-600" />
              </div>
            </div>
          </div>
        );
      
      case 'schedule':
        return (
          <div className={visualStyles}>
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-2xl flex items-center justify-center">
                <Calendar className="w-10 h-10 text-blue-600" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <span className="text-white text-xs font-bold">⏰</span>
              </div>
            </div>
          </div>
        );
      
      case 'connect':
        return (
          <div className={visualStyles}>
            <div className="relative w-full h-full flex items-center justify-center">
              <div className="w-12 h-12 bg-gradient-to-br from-green-100 to-teal-100 rounded-xl flex items-center justify-center">
                <Globe className="w-6 h-6 text-green-600" />
              </div>
              
              {/* Instagram */}
              <div className="absolute top-2 left-1/4 w-8 h-8 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 rounded-lg flex items-center justify-center shadow-lg">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </div>
              
              {/* TikTok */}
              <div className="absolute top-2 right-1/4 w-8 h-8 bg-black rounded-lg flex items-center justify-center shadow-lg">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </div>
              
              {/* Gmail */}
              <div className="absolute bottom-2 left-1/3 w-8 h-8 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center shadow-lg">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-.904.732-1.636 1.636-1.636h.682L12 10.817l9.682-6.996h.682A1.636 1.636 0 0 1 24 5.457z"/>
                </svg>
              </div>
              
              {/* Stripe */}
              <div className="absolute bottom-2 right-1/3 w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-lg">
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.831 3.47 1.426 3.47 2.338 0 .914-.796 1.431-2.127 1.431-1.72 0-4.516-1.053-6.378-2.349l-.889 5.52c1.786 1.039 4.981 1.976 8.976 1.976 2.585 0 4.732-.624 6.199-1.588 1.544-1.027 2.336-2.793 2.336-5.026 0-4.128-2.524-5.851-6.594-7.305h.001z"/>
                </svg>
              </div>
            </div>
          </div>
        );
      
      case 'optimize':
        return (
          <div className={visualStyles}>
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-to-br from-green-100 to-emerald-100 rounded-2xl flex items-center justify-center">
                <TrendingUp className="w-10 h-10 text-green-600" />
              </div>
              <div className="absolute -top-2 -right-2 px-2 py-1 bg-green-500 rounded-full">
                <span className="text-white text-xs font-bold">+127%</span>
              </div>
            </div>
          </div>
        );
      
      default:
        return <div className={visualStyles}></div>;
    }
  };
  
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-green-50/30">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          {/* <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How Kinos Works
          </h2> */}
          <h3 className="text-xl text-gray-600 max-w-2xl mx-auto">
            5 simple steps that transform marketing chaos into automated success
          </h3>
        </div>
        
        {/* Cards Container */}
        <div className="relative">
          {/* Desktop Navigation Arrows */}
          <div className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10">
            <button 
              className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-200"
              onClick={() => {
                const prevIndex = activeCardIndex === 0 ? features.length - 1 : activeCardIndex - 1;
                scrollToCard(prevIndex);
              }}
            >
              <ArrowRight className="w-5 h-5 text-green-600 rotate-180" />
            </button>
          </div>
          
          <div className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10">
            <button 
              className="bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-200"
              onClick={() => {
                const nextIndex = (activeCardIndex + 1) % features.length;
                scrollToCard(nextIndex);
              }}
            >
              <ArrowRight className="w-5 h-5 text-green-600" />
            </button>
          </div>
          
          {/* Mobile Swipe Indicator */}
          <div className="md:hidden absolute right-4 top-8 z-20 flex items-center pointer-events-none">
            <span className="text-sm font-semibold text-gray-600 bg-white/90 rounded-full px-3 py-1 shadow-md mr-2">
              Swipe
            </span>
            <ArrowRight className="w-5 h-5 text-gray-600 animate-pulse" />
          </div>

          {/* Cards */}
          <div 
            ref={cardsContainerRef}
            className="flex overflow-x-auto snap-x snap-mandatory pb-6 scrollbar-hide"
            style={{ WebkitOverflowScrolling: 'touch' }}
          >
            {features.map((feature, index) => (
              <div 
                key={feature.id}
                className="feature-card snap-center w-[85%] sm:w-80 md:w-72 lg:w-80 flex-shrink-0 mx-2 first:ml-4 last:mr-4"
              >
                <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 h-96 flex flex-col overflow-hidden group hover:scale-[1.02] border border-gray-100">
                  {/* Visual Section */}
                  <div className="bg-gradient-to-br from-gray-50 to-white flex-shrink-0">
                    {renderVisual(feature.visual)}
                  </div>
                  
                  {/* Content Section */}
                  <div className="p-8 flex flex-col justify-between flex-grow">
                    <div>
                      <div className="flex items-center mb-4">
                        <div className="bg-green-100 rounded-xl p-2 mr-3">
                          {React.cloneElement(feature.icon, { className: 'w-5 h-5 text-green-700' })}
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
                          <p className="text-green-700 font-semibold text-sm">{feature.subtitle}</p>
                        </div>
                      </div>
                      
                      <p className="text-gray-600 text-lg leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Pagination Dots */}
          <div className="flex justify-center mt-8 gap-3">
            {features.map((_, index) => (
              <button
                key={index}
                onClick={() => {
                  scrollToCard(index);
                  setActiveCardIndex(index);
                }}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === activeCardIndex 
                    ? 'bg-green-600 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`View ${features[index].title} feature`}
              />
            ))}
          </div>
        </div>

        {/* Demo Image */}
        <div className="mt-16 flex justify-center">
          <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-200 p-4">
            <img 
              src="/demo_view_1.png" 
              alt="Kinos Dashboard" 
              className="rounded-xl w-full h-auto object-contain"
              style={{ background: '#f8fafc' }}
            />
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default MinimalFeatureCards;